import { apiInstance } from '../client'
import { getTempleId } from 'api/temple'
import {
    WhatsAppPackageType,
    WhatsAppTemplateType,
    WhatsAppWalletType,
    WhatsAppTransactionType,
    WhatsAppRechargeType,
    InitiateRechargeResponse,
    WhatsAppTemplateListParams,
} from './types'

const basePath = 'whatsapp/t-admin'

export const whatsappPackageApi = {
    list: async (templeId?: string | number) =>
        await apiInstance.get<WhatsAppPackageType[]>(`${basePath}/packages/`, { templeId: getTempleId(templeId) }),
}

export const whatsappTemplateApi = {
    list: async (params?: WhatsAppTemplateListParams, templeId?: string | number) =>
        await apiInstance.get<{ count: number; next: string | null; previous: string | null; results: WhatsAppTemplateType[] }>(
            `${basePath}/templates/`,
            { params, templeId: getTempleId(templeId) }
        ),
    get: async (id: number, templeId?: string | number) =>
        await apiInstance.get<WhatsAppTemplateType>(`${basePath}/templates/${id}/`, { templeId: getTempleId(templeId) }),
}

export const whatsappWalletApi = {
    getWallet: async (templeId?: string | number) =>
        await apiInstance.get<WhatsAppWalletType>(`${basePath}/wallet/`, { templeId: getTempleId(templeId) }),
    listTransactions: async (templeId?: string | number) =>
        await apiInstance.get<WhatsAppTransactionType[]>(`${basePath}/wallet/transactions/`, { templeId: getTempleId(templeId) }),
    getTransaction: async (id: number, templeId?: string | number) =>
        await apiInstance.get<WhatsAppTransactionType>(`${basePath}/wallet/transactions/${id}/`, { templeId: getTempleId(templeId) }),
    listRecharges: async (templeId?: string | number) =>
        await apiInstance.get<WhatsAppRechargeType[]>(`${basePath}/wallet/recharges/`, { templeId: getTempleId(templeId) }),
    getRecharge: async (id: number, templeId?: string | number) =>
        await apiInstance.get<WhatsAppRechargeType>(`${basePath}/wallet/recharges/${id}/`, { templeId: getTempleId(templeId) }),
    initiateRecharge: async (packageId: number, templeId?: string | number) =>
        await apiInstance.post<InitiateRechargeResponse>(
            `${basePath}/wallet/recharges/recharge/`,
            { package_id: packageId },
            { templeId: getTempleId(templeId) }
        ),
}
